import React from "react";
import cx from "classnames";
import { ValidationMessage } from "../validationMessage";

import Wrapper from "./verification.styles";

export default function Verification({ ...props }) {
  const {
    title,
    leftButtonProps,
    leftButtonLabel,
    rightButtonProps,
    rightButtonLabel,
    errorMessage,
    toolTipText,
    OptionalLabel,
    className,
    ...rest
  } = props;

  return (
    <Wrapper>
      <div className={cx("verification", className)}>
        <p>{title}</p>
        <div className="verification-options">
          <div className="option-container">
            <label>
              <input {...rest}{...leftButtonProps} type="radio" />
              {leftButtonLabel}
            </label>
          </div>
          <div>
            <label >
              <input {...rest}{...rightButtonProps} type="radio" />
              {rightButtonLabel}
            </label>
          </div>
        </div>
        <ValidationMessage errorMessage={errorMessage} />
      </div>
    </Wrapper >
  );
}
